import React, { useEffect, useState } from "react";
import TableHeading from "../../components/common/TableHeading";
import { RIGHTARROW_ICON } from "../../../utills/image-constant";
import Inputwithlable from "../../components/common/inputwithlable";
import DropDownWithLabel from "../../components/common/DropDownWithlable";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import { handleFormInput } from "../../../utills/formutilities";
import Loginbtn from "../../components/common/loginbtn";
import { useLocation, useNavigate } from "react-router-dom";
import {
  checkValidation,
  ErrorMessage,
  ErrorMsg,
} from "../../../utills/error-message-constant";
import {
  alphaletter,
  emailRegex,
  NumberRegex,
} from "../../../utills/form-regex";
import PhoneInput from "react-phone-input-2";
import {
  addEmployee,
  addUpdateCompanyAssessorForm,
  getAllCompanies,
  getAllDepartment,
  getAllHirarchy,
  getAssessorsList,
} from "../../../services/api-services";
import { ROUTES } from "../../routes/url-constant";

const AddAssignedAssessor = () => {
  const location = useLocation();
  const navigate = useNavigate();

  let Assessortype = location?.state?.pageType;
  let editAssessorData = location?.state?.Data;


  const [Assessorbtndisable, setAssessorbtndisable] = useState(false);
  const [formError, setFormError] = useState({});
  const [AssessorbtnLoader, setAssessorbtnLoader] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [hierarchyOptions, setHierarchyOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [assessors, setAssessors] = useState([]);
  const [assessoremail, setAssessorEmail] = useState("");
  const [assessorData, setAssessorData] = useState({
    id: editAssessorData?.id || "",
    assessorId: editAssessorData?.adminResponsePayload?.id || "",
    departmentId: editAssessorData?.department?.id || "",
    hierarchyId: editAssessorData?.hierarchy?.id || "",
    departmentType: editAssessorData?.department?.other ? "Other" : "",
    hierarchyType: editAssessorData?.hierarchy?.other ? "Other" : "",
    companyId: editAssessorData?.companyResponse?.id || "",
  });

  console.log('assessors----------------------', assessors);


  useEffect(() => {
    setAssessorEmail(editAssessorData?.adminResponsePayload?.email);
  }, [editAssessorData]);
  // API Calls
  const getallCompany = async (status) => {
    try {
      const response = await getAllCompanies(status);
      if (response?.data?.responseCode === 200) {
        const companyOptions = response?.data?.responseBody?.map((data) => ({
          value: data?.id,
          label: data?.companyName,
          modelName: data?.modelResponse?.modelName,
          modelId: data?.modelId,
        }));
        setCompanyList(companyOptions);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const getAssessors = async () => {
    try {
      const assessorPayload = {
        pageIndex: 0,
        pageSize: 10,
        searchText: "",
        direction: "desc",
        filterByFieldName: "id",

      }
      const response = await getAssessorsList(assessorPayload);


      if (response?.data?.responseCode === 200) {
        const assessorsList = response?.data?.responseBody?.adminResponsePayloadList
          ?.filter((data) => data?.status === 1)  // Only include items with status 1
          .map((data) => ({
            value: data?.id,
            label: data?.name,
            email: data?.email,
          }));
        setAssessors(assessorsList);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const getAllDepartmentData = async (companyId) => {
    try {
      const response = await getAllDepartment(companyId);
      if (response?.data?.responseCode === 200) {
        const departments = response?.data?.data || [];
        const options = departments.map((dept) => ({
          id: dept?.id,
          value: dept?.departmentName,
          label: dept?.departmentName,
        }));
        setDepartmentOptions(options);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  const getAllHierarchyData = async (companyId) => {
    try {
      const response = await getAllHirarchy(companyId);
      if (response?.data?.responseCode === 200) {
        const hierarchies = response?.data?.data || [];
        const options = hierarchies.map((item) => ({
          id: item?.id,
          value: item?.hierarchyName,
          label: item?.hierarchyName,
        }));
        setHierarchyOptions(options);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  };

  useEffect(() => {
    getallCompany(1);
    getAssessors();
  }, []);

  useEffect(() => {
    if (assessorData.companyId) {
      getAllDepartmentData(assessorData.companyId);
      getAllHierarchyData(assessorData.companyId);
    }
  }, [assessorData.companyId]);

  const assessorhandleSelect = (e) => {
    const selectedValue = e.target.value;
    console.log('e.target.value', selectedValue);

    // Check if the selected value is empty
    if (!selectedValue) {
      // If empty, clear the email and reset other state values if necessary
      setAssessorEmail('');
      setAssessorData((prev) => {
        const updated = { ...prev, assessorId: '' };  // Reset assessorId or any other values
        return updated;
      });
      return; // Exit early if value is empty
    }

    // Find the selected assessor
    const selectedAssessors = assessors?.find(
      (assessor) => assessor.value === selectedValue
    );

    // If a valid assessor is found, update the state
    if (selectedAssessors) {
      setAssessorEmail(selectedAssessors?.email);
      setAssessorData((prev) => {
        const updated = { ...prev, assessorId: selectedAssessors?.value };
        return updated;
      });
    }
  };

  // Handle dropdown changes
const handleSelect = (event) => {
  const { name, value } = event.target;

  // If "Select All" or "Other" is selected, reset or modify the state accordingly
  if (name === "departmentId") {
    if (value === "Select All" || value === "") {
      setAssessorData({
        ...assessorData,
        departmentId: "",  // Reset departmentId
        departmentType: "", // Reset departmentType
      });
    } else {
      const selecteddepartmentId = departmentOptions?.find(
        (department) => department.value === value
      );
      setAssessorData({
        ...assessorData,
        departmentId: value === "Other" ? "" : selecteddepartmentId?.id,
        departmentType: value === "Other" ? "Other" : "",
      });
    }
  } else if (name === "hierarchyId") {
    if (value === "Select All" || value === "") {
      setAssessorData({
        ...assessorData,
        hierarchyId: "",
        hierarchyType: "",
      });
    } else {
      const selectedhierarchy = hierarchyOptions?.find(
        (hierarchy) => hierarchy.value === value
      );
      setAssessorData({
        ...assessorData,
        hierarchyId: value === "Other" ? "" : selectedhierarchy?.id,
        hierarchyType: value === "Other" ? "Other" : "",
      });
    }
  } else if (name === "companyId") {
    if (value === "Select All" || value === "") {
      setAssessorData({
        ...assessorData,
        companyId: "",
        modelId: "",
        modelName: "",
      });
    } else {
      const selectedCompany = companyList.find((c) => c.value === value);
      setAssessorData({
        ...assessorData,
        companyId: value,
        modelId: selectedCompany?.modelId || "",
        modelName: selectedCompany?.modelName || "",
      });
    }
  }
};


  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;


    if (name === "departmentType") {
      setAssessorData({
        ...assessorData,
        departmentId: value,
        departmentType: "Other",
      });
    } else if (name === "hierarchyType") {
      setAssessorData({
        ...assessorData,
        hierarchyId: value,
        hierarchyType: "Other",
      });
    } else {
      setAssessorData(handleFormInput(e, assessorData));
    }
  };

  const [isNumber, setIsNumber] = useState("us");
  const handleNumber = (e) => {

  };
  const handleAddEmployee = async () => {
    if (
      !assessorData?.assessorId ||
      !assessorData?.companyId ||
      !assessorData?.departmentId ||
      !assessorData?.hierarchyId
    ) {
      toastEmitter("error", "All fields are required");
      return;
    }

    const payload = {
      id: assessorData?.id || "",
      assessorId: assessorData?.assessorId || "",
      departmentId: assessorData?.departmentId || "",
      hierarchyId: assessorData?.hierarchyId || "",
      departmentType: assessorData?.departmentType || "",
      hierarchyType: assessorData?.hierarchyType || "",
      companyId: assessorData?.companyId || "",
    };

    console.log('payload', payload);

    setAssessorbtnLoader(true);
    setAssessorbtndisable(true);

    try {
      const response = await addUpdateCompanyAssessorForm(payload);
      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
        navigate(ROUTES.ASSESSORMANAGEMENT);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setAssessorbtnLoader(false);
      setAssessorbtndisable(false);
    }

  };

  return (
    <>
      <TableHeading
        className="cursor-pointer"
        firstData="Customer Management"
        icon={RIGHTARROW_ICON}
        secondData="Assessor Management"
        iconshow={true}
        thirdData={
          Assessortype === "Edit"
            ? "Update Assessor"
            : Assessortype === "View"
              ? "View Assessor"
              : "Add Assessor"
        }
        onFirstDataClick={() => navigate(ROUTES.ASSESSORMANAGEMENT)}
      />

      <div className="container-fluid ">
        <div className="caspera_employee_add">
          <div className="row">
            {/* Employee Name */}
            <div className="col-md-4">

              <DropDownWithLabel

                disabled={Assessortype === "Edit" || Assessortype === "View"}
                labelName="Select Assessor"
                name="assessorId"
                lableclassName="addInput-label"
                options={assessors}
                showastrict={true}
                className="form-control addInputText-lable"
                handleSelect={assessorhandleSelect}
                value={assessorData.assessorId}
              />
            </div>
            <div className="col-md-4">
              <Inputwithlable
                disable={true}
                placeHolder="Enter Email"
                name="email"
                lableclassName="addInput-label"
                showastrict={true}
                type="text"
                className="form-control addInputText-lable"
                labelName="Enter Email"
                value={assessoremail}
              />
            </div>
            {/* Company */}
            <div className="col-md-4">
              <DropDownWithLabel
                disabled={Assessortype === "Edit" || Assessortype === "View"}
                labelName="Select Company"
                name="companyId"
                lableclassName="addInput-label"
                options={companyList}
                showastrict={true}
                className="form-control addInputText-lable"
                handleSelect={handleSelect}
                value={assessorData.companyId}
              />
            </div>

            {/* Email */}




            {/* Department Dropdown */}
            <div className="col-md-6">
              <DropDownWithLabel
                labelName="Select Department"
                name="departmentId"
                showastrict={true}
                lableclassName="addInput-label"
                options={departmentOptions}
                handleSelect={handleSelect}
                value={
                  assessorData.departmentType === "Other"
                    ? "Other"
                    : departmentOptions.find((opt) => opt.id === assessorData.departmentId)?.value || ""
                }
                className="form-control addInputText-lable"
                disabled={Assessortype === "Edit" || Assessortype === "View"}
              />
              {/* Show input if "Other" selected */}
              {assessorData.departmentType === "Other" && (
                <div className="col-md-12">
                  <Inputwithlable
                    disabled={Assessortype === "Edit" || Assessortype === "View"}
                    placeHolder="Enter Custom Department"
                    name="departmentType"
                    lableclassName="addInput-label"
                    type="text"
                    showastrict={true}
                    labelName="Other Department"
                    handleChange={handleChange}
                    className="form-control addInputText-lable"
                    value={assessorData.departmentId}
                  />
                </div>
              )}
            </div>



            {/* Hierarchy Dropdown */}
            <div className="col-md-6">
              <DropDownWithLabel
                labelName="Select Hierarchy"
                name="hierarchyId"
                showastrict={true}
                lableclassName="addInput-label"
                options={hierarchyOptions}
                handleSelect={handleSelect}
                className="form-control addInputText-lable"
                value={
                  assessorData.hierarchyType === "Other"
                    ? "Other"
                    : hierarchyOptions.find(opt => opt.id === assessorData.hierarchyId)?.value || ""
                }
                disabled={Assessortype === "Edit" || Assessortype === "View"}
              />
              {/* Show input if "Other" selected */}
              {assessorData.hierarchyType === "Other" && (
                <div className="col-md-12">
                  <Inputwithlable
                    disabled={Assessortype === "Edit" || Assessortype === "View"}
                    placeHolder="Enter Custom Hierarchy"
                    name="hierarchyType"
                    lableclassName="addInput-label"
                    type="text"
                    showastrict={true}
                    labelName="Other Hierarchy"
                    className="form-control addInputText-lable"
                    handleChange={handleChange}
                    value={assessorData.hierarchyId}
                  />
                </div>
              )}
            </div>


          </div>

          {/* Submit Button */}
          {Assessortype !== "view" && (
            <div className="pt-4 d-flex justify-content-center">
              <Loginbtn
                className="submitbtn px-5"
                handleClick={handleAddEmployee}
                type="submit"
                btnName={Assessortype === "Edit" ? "Update" : "ADD"}
                disablebtn={Assessorbtndisable}
                loader={AssessorbtnLoader}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddAssignedAssessor;
